import styled from 'styled-components';
import { ASSETS } from '../../../../assets';
import { THEME } from '../../../../themes';
import { HeadlineFont, OverlineFont } from '../../../../themes/fonts';
import { fadeInAnimation } from '../../../../animations';
import { ELEMENTS_DURATION } from '../../../../consts/durations';

export const SuggestionContainer = styled.div`
`;

export const SuggestionTitleContainer = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const SuggestionTitle = styled.div`
  ${OverlineFont};
  font-weight: 400;
  text-transform: uppercase;
  text-align: left;
  opacity: 0.6;
  color: ${THEME.COLORS.CONTENT_A};
  padding-left: ${THEME.SPACING.MICRO};
`;

export const AutocompleteItem = styled.div`
  ${HeadlineFont};
  font-weight: 400;
  min-height: 64px;
  padding: ${THEME.SPACING.BASE};
  color: ${({ color }) => color};
  display: flex;
  gap: ${THEME.SPACING.TINO};
  align-items: start;
  transition: all ease-in .2s;
  cursor: pointer;
`;

export const ListStartIcon = styled(ASSETS.LIST_START)`
  opacity: 0.6;
  fill: ${THEME.COLORS.CONTENT_A};
`;

export const HoriDotsIcon = styled(ASSETS.HORI_DOTS)`
  opacity: 0.6;
  fill: ${THEME.COLORS.CONTENT_A};
`;

export const SuggestionContentContainer = styled.div`
  min-height: 50px;
  display: flex;
  flex-wrap: wrap;
`;

export const ContentContainer = styled(SuggestionContentContainer)`
  display: flex;
  flex-wrap: wrap;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${THEME.SPACING.MICRO};
`;

export const InputWrapper = styled.div`
  padding-left: 12px;
  input {
    border: 0 !important;
  }
`;

export const SuggestionListContainer = styled.div`
  display: inline-flex;
  margin-right: ${THEME.SPACING.TINY};
  margin-top: ${THEME.SPACING.TINY};
  margin-bottom: ${THEME.SPACING.TINY};
  animation: ${fadeInAnimation({
    animationDuration: ELEMENTS_DURATION.JOB_DESCRIPTION_TITLE_DURATION,
    animationDelay: 0,
  })
}
`;
